import { render } from "./DigitalHealth.vue?vue&type=template&id=1da20efc&scoped=true"
import script from "./DigitalHealth.vue?vue&type=script&lang=js"
export * from "./DigitalHealth.vue?vue&type=script&lang=js"

import "./DigitalHealth.vue?vue&type=style&index=0&id=1da20efc&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da20efc"]])

export default __exports__